import {
	adminEndpoints,
	apiEndpoints,
	websiteEndpoints,
	type EnvironmentName,
} from '@workinance/shared/config/environment';

// Rewritten by scripts/setEnvironment.mjs before `vite dev`/`vite build` run.
// Mirrors Angular's environment.ts file-replacement pattern in a single file:
// application code always imports `apiUrl` from here, never process.env.
const ACTIVE_ENVIRONMENT: EnvironmentName = 'staging';

export const apiUrl: string = apiEndpoints[ACTIVE_ENVIRONMENT];

// Where the admin app lives, for sending owners to register/manage their business.
export const adminUrl: string = adminEndpoints[ACTIVE_ENVIRONMENT];

// The public marketing site, linked from the sign in and register pages.
export const websiteUrl: string = websiteEndpoints[ACTIVE_ENVIRONMENT];
